/**
 *
 * Asynchronously loads the component for FrameWithGuides
 *
 */

import { lazyLoad } from 'utils/loadable';

export const FrameWithGuides = lazyLoad(
  () => import('./index'),
  module => module.FrameWithGuides,
);
